// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-slider/styles.less
// module id = 1146
// module chunks = 10